
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component({})
export default class TransitionExpand extends Vue {
  @Prop({ type: String, default: 'auto' }) height: number | string;

  afterEnter(element: { style: { height: string } }) {
    element.style.height = <string>this.height;
  }

  enter(element: HTMLElement) {
    element.style.position = 'absolute';
    element.style.visibility = 'hidden';
    element.style.height = <string>this.height;

    const height = this.height === 'auto' ? getComputedStyle(element).height : this.height;

    element.style.position = null;
    element.style.visibility = null;
    element.style.height = '0';

    getComputedStyle(element).height;

    this.$nextTick(() => {
      element.style.height = <string>height;
      //Prevent scroll on mobile
      window.scrollTo(0, 0);
    });
  }

  leave(element: HTMLElement) {
    const height = this.height === 'auto' ? getComputedStyle(element).height : this.height;

    element.style.height = <string>height;

    getComputedStyle(element).height;

    this.$nextTick(() => {
      element.style.height = '0';
    });
  }
}
